export const SET_DASHBOARD_PARAMETERS = "SET_DASHBOARD_PARAMETERS";

export const setDashBoard = (params) => ({
  type: SET_DASHBOARD_PARAMETERS,
  payload: params,
});
